import { Component, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { LucideAngularModule } from 'lucide-angular';

export interface BreadcrumbItem {
  label: string;
  routerLink?: string[];
  /** Ex.: voltar à vista principal do workflow a partir de Formulários (mesma URL). */
  queryParams?: Record<string, string | number | boolean | null | undefined>;
}

@Component({
  selector: 'app-page-header',
  standalone: true,
  imports: [RouterLink, LucideAngularModule],
  templateUrl: './page-header.component.html',
})
export class PageHeaderComponent {
  /** Título principal da página */
  title = input.required<string>();
  /** Subtítulo (ex.: "Lista · 5 itens") */
  subtitle = input<string>('');
  /** Título grande (premium): true = text-2xl */
  titleLarge = input<boolean>(false);
  /** Itens do breadcrumb (label + routerLink opcional) */
  breadcrumbs = input<BreadcrumbItem[]>([]);
}
